import { createSlice } from '@reduxjs/toolkit';
import { IInsuranceProductsState } from './types';
import { InsuranceProductsReducer } from '../../reducers/InsuranceProductsReducer';

const initialState: IInsuranceProductsState = {
  products: [],
  isLoaded: false
};

export const insuranceProductsSlice = createSlice({
  name: 'insuranceProducts',
  initialState,
  reducers: InsuranceProductsReducer
});

export const { setInsuranceProducts, updateProductVisibility, resetInsuranceProducts } = insuranceProductsSlice.actions;
export default insuranceProductsSlice.reducer; 